if (!Alpine.store('phoneManager')) {
    Alpine.store('phoneManager', {
        states: {},
        statesUniqueWidget: {},

        initState(key, config) {
            if (this.states[key]) {
                return;
            }
            this.states[key] = {
                mainNumber: config.mainPhoneNumber,
                secondaryNumbers: [],
                eventsOnHref: [],
                showPhoneNumber: config.showPhoneNumber,
                isLoading: false,
            };
        },

        initStateUniqueWidget(key, config) {
            if (this.statesUniqueWidget[key]) {
                return;
            }
            this.statesUniqueWidget[key] = {
                buttonText: config.buttonText !== undefined ? config.buttonText : '',
                defaultClass: config.defaultClass ?? '',
                noViewClass: config.noViewClass ?? '',
                viewClass: config.viewClass ?? '',
            };
        },
    });
}
export default config => ({
    entityId: config.entityId,
    entityType: config.entityType,
    incrementPhoneKpiEvent: config.incrementPhoneKpiEvent,
    source: config.source,
    apiUrl: config.apiUrl,
    eventType: config.eventType,
    contactData: config.contactData,
    isProductionEnv: config.isProductionEnv,
    loading: false,
    error: null,
    uniqueKey: '',
    uniqueWidgetKey: '',
    init() {
        this.uniqueKey = `${this.entityId}-${this.eventType}`;
        this.uniqueWidgetKey = `${this.entityId}-${this.eventType}-${config.context}`;
        Alpine.store('phoneManager').initState(this.uniqueKey, config);
        Alpine.store('phoneManager').initStateUniqueWidget(this.uniqueWidgetKey, config);
        Alpine.store('phoneManager').states[this.entityId] = {
            mainNumber: config.mainPhoneNumber,
        };
        if (this.isPhoneNumberShowed) {
            this.$el.className = this.dynamicClasses;
        }
    },
    get state() {
        return Alpine.store('phoneManager').states[this.uniqueKey];
    },
    get statesUniqueWidget() {
        return Alpine.store('phoneManager').statesUniqueWidget[this.uniqueWidgetKey];
    },
    get currentMainPhoneNumber() {
        return this.state?.mainNumber;
    },
    get currentSecondaryPhoneNumbers() {
        return this.state?.secondaryNumbers;
    },
    get isPhoneNumberShowed() {
        return this.state?.showPhoneNumber;
    },
    get isLoading() {
        return this.state?.isLoading;
    },
    get buttonTextOrPhone() {
        if (this.statesUniqueWidget && !this.isPhoneNumberShowed) {
            return this.statesUniqueWidget.buttonText;
        }

        return this.currentMainPhoneNumber;
    },
    get dynamicClasses() {
        if (!this.statesUniqueWidget) {
            return config.defaultClass;
        }

        let classes = [this.statesUniqueWidget.defaultClass];
        if (this.isPhoneNumberShowed) {
            classes.push(this.statesUniqueWidget.viewClass);
        } else {
            classes.push(this.statesUniqueWidget.noViewClass);
        }

        return classes.join(' ');
    },
    get callAfterResponse() {
        return config.eventType === 'call-phone';
    },
    sendEvents(events) {
        if (window.dataLayer && Array.isArray(events) && events.length > 0) {
            events.forEach(([eventName, data]) => {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: eventName,
                        ...data,
                    });

                    if (!this.isProductionEnv) {
                        console.log('Datalayer push event: ', eventName, data);
                    }
                }
            });
        }
    },
    updateMyClasses(updatedKey) {
        if (updatedKey !== this.uniqueKey) {
            return;
        }

        this.$el.className = this.dynamicClasses;
    },
    handlePhoneCall() {
        const events = this.state?.eventsOnHref;

        this.sendEvents(events);

        setTimeout(() => {
            window.location.href = `tel:${this.currentMainPhoneNumber.replace(/\s/g, '')}`;
        }, 100);
    },
    async revealPhoneNumber() {
        if (this.isLoading) {
            return; //we prevent running multiple time in the same time for detail pages
        }

        const currentState = Alpine.store('phoneManager').states[this.uniqueKey];
        currentState.isLoading = true;

        if (this.isPhoneNumberShowed) {
            this.handlePhoneCall();
            currentState.isLoading = false;
            return;
        }

        this.error = null;
        this.loading = true;

        try {
            const response = await fetch(this.apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')
                        ? document.querySelector('meta[name="csrf-token"]').content
                        : '',
                },
                body: JSON.stringify({
                    entity_id: this.entityId,
                    incrementPhoneKpiEvent: this.incrementPhoneKpiEvent,
                    entity_type: this.entityType,
                    source: this.source,
                    eventType: this.eventType,
                    contactData: this.contactData,
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP Error: ${response.status} ${response.statusText}`);
            }

            const data = await response.json();

            currentState.mainNumber = data.main;
            currentState.secondaryNumbers = data.more ?? [];
            currentState.showPhoneNumber = true;

            Alpine.store('phoneManager').states[this.entityId].mainNumber = data.main;

            if (data.onClick && typeof data.onClick === 'object' && Object.keys(data.onClick).length > 0) {
                currentState.eventsOnHref = Object.entries(data.onClick);
            }

            this.$dispatch('phonestate-updated', { key: this.uniqueKey });

            if (this.incrementPhoneKpiEvent.length && window.Livewire && this.contactData?.phoneClass) {
                Livewire.dispatch(this.incrementPhoneKpiEvent, {
                    entityId: this.entityId,
                    data: {
                        gtmClickClass: this.contactData.phoneClass,
                    },
                });
            }

            if (data.onResponse && typeof data.onResponse === 'object' && Object.keys(data.onResponse).length > 0) {
                this.sendEvents(Object.entries(data.onResponse));
            }

            if (this.callAfterResponse) {
                this.handlePhoneCall();
            }
        } catch (e) {
            this.error = 'Error fetching: ' + e.message;
            console.error('AJAX Error:', e);
        } finally {
            this.loading = false;
            currentState.isLoading = false;
        }
    },
});
